import './HeroCard.css';
import { heroDisplayName } from './utils/heroDisplayName';

interface HeroCardProps {
  hero: {
    hero_id: number;
    hero_name: string;
    head_url: string | null;
    win_rate: number;
    pick_rate: number;
    ban_rate: number;
    rank_position: number;
  };
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

export default function HeroCard({ 
  hero, 
  onMouseEnter, 
  onMouseLeave 
}: HeroCardProps) {
  const name = heroDisplayName(hero.hero_id, hero.hero_name);
  return (
    <div
      className="hero-card"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="hero-icon">
        {hero.head_url ? (
          <img 
            src={hero.head_url} 
            alt={name}
            className="hero-image"
            onError={(e) => {
              // Fallback to placeholder if image fails to load
              const target = e.target as HTMLImageElement;
              target.style.display = 'none';
              const parent = target.parentElement;
              if (parent) {
                const placeholder = document.createElement('div');
                placeholder.className = 'hero-image-placeholder';
                placeholder.textContent = name.charAt(0);
                parent.appendChild(placeholder);
              }
            }}
          />
        ) : (
          <div className="hero-image-placeholder">
            {name.charAt(0)}
          </div>
        )}
      </div>
      <div className="hero-name">{name}</div>
    </div>
  );
}